import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import Login from "./pages/Login";
import OrderList from "./pages/OrderList";
import { useAuthStore } from "../console/store/useAuthStore";
import { BRANCH_BASE_PATH, LOGIN_PATH } from "./tenant";

const BRANCH_LEVEL = 6;

const PORTAL_TITLE = "원일 지점 포털";

/**
 * 지점계정 전용 가드
 *
 * 화면 보호일 뿐 보안 경계가 아니다. 실제 격리는 백엔드의 branch-scope /
 * branch-ownership 미들웨어가 담당한다.
 */
const RequireBranchAuth = ({ children }: { children: React.ReactNode }) => {
    const accessToken = useAuthStore(state => state.accessToken);
    const m_level = useAuthStore(state => state.m_level);

    if (!accessToken || m_level !== BRANCH_LEVEL) {
        return <Navigate to={LOGIN_PATH} replace />;
    }

    return <>{children}</>;
};

const Branch = () => {
    const location = useLocation();

    // 브라우저 탭 타이틀. index.html 기본값이 "고려원예"이고 콘솔은 navBar 에서 따로 잡는다
    useEffect(() => {
        const menu = location.pathname.startsWith(`${BRANCH_BASE_PATH}/transaction`) ? "주문판매" : "";
        document.title = menu ? `${PORTAL_TITLE} - ${menu}` : PORTAL_TITLE;
    }, [location.pathname]);

    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route
                path="transaction"
                element={
                    <RequireBranchAuth>
                        <OrderList />
                    </RequireBranchAuth>
                }
            />
            <Route path="*" element={<Navigate to={LOGIN_PATH} replace />} />
        </Routes>
    );
};

export default Branch;
